import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { toast } from '@/hooks/use-toast';

export const useOrderNotifications = () => {
  useEffect(() => {
    const channel = supabase
      .channel('order-notifications')
      .on(
        'postgres_changes',
        {
          event: 'UPDATE',
          schema: 'public',
          table: 'orders',
        },
        (payload: any) => {
          const newStatus = payload.new?.status;
          const oldStatus = payload.old?.status;
          
          // Notificare când comanda devine completed
          if (newStatus === 'completed' && oldStatus !== 'completed') {
            const email = payload.new?.email;
            
            toast({
              title: "✅ Document Gata!",
              description: `Documentul tău a fost procesat și livrat pe ${email}. Verifică inbox-ul!`,
              duration: 10000,
            });
          }
          
          // Notificare când comanda este anulată
          if (newStatus === 'cancelled' && oldStatus !== 'cancelled') {
            toast({
              title: "⚠️ Comandă Anulată",
              description: "Comanda ta a fost anulată. Vei primi un email cu detaliile.",
              variant: "destructive",
              duration: 8000,
            });
          }
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, []);
};
